"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var TextInput = function (props) {
    var theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Box, { minHeight: "50px" }, props.isEditing ?
        (react_1.default.createElement(StyledTextField, { size: "small", fullWidth: true, margin: "dense", type: props.type || 'string', label: props.label, variant: "standard", required: props.required || false, disabled: props.disabled || false, error: props.error, value: props.value, multiline: props.multiline, name: props.name, helperText: props.helperText, onBlur: props.onBlur, onChange: props.onChange, InputProps: __assign({}, props.InputProps), inputProps: __assign({}, props.inputProps), title: props.title, rows: props.rows }))
        :
            (react_1.default.createElement(material_1.FormControl, { disabled: props.disabled },
                react_1.default.createElement(material_1.Typography, { variant: "overline", display: "block", color: props.disabled ? theme.palette.action.disabled : undefined }, props.label),
                react_1.default.createElement("span", { style: {
                        color: props.disabled ? theme.palette.action.disabled : "inherit",
                        overflowWrap: props.wrapTextValue ? "anywhere" : "normal"
                    } }, props.value || react_1.default.createElement("span", null, "N/A"))))));
};
var StyledTextField = (0, material_1.styled)(material_1.TextField)(function (_a) {
    var theme = _a.theme;
    return ({
        marginTop: 0,
        marginBottom: theme.spacing(2),
    });
});
exports.default = TextInput;
